<template>
  <LoadingOverlay :isLoading="loading"></LoadingOverlay>
  <div class="container-fluid ">
    <div class="card">
      <div class="card-header btn-outline-success" @click="showDetails" role="button">
        <strong>
          {{ structure.pdb }} :
        </strong>
        Structure:
        <span class="bi bi-check-circle-fill text-success" v-if="structure.alreadyLoaded"></span>
        <span class="bi bi-x-circle-fill text-danger" v-else></span>
        Sequence:
        <span class="bi bi-check-circle-fill text-success" v-if="structure.sequence"></span>
        <span class="bi bi-x-circle-fill text-danger" v-else></span>
      </div>
      <div class="card-body" v-show="detailsShown">
        <h5 class="card-title">Details</h5>
        <div class="input-group mb-3">
          <input disabled class="form-control" type="number" name="id" v-model="structure.id">
          <span class="input-group-text">ID in database</span>
          <a :href="'/structure?structureId=' + structure.id" target="_blank" v-if="structure.id" title="Open in plic"
             class="btn btn-outline-secondary" type="button"><span class="bi bi-arrow-up-right-square"></span></a>
        </div>
        <div class="input-group mb-3">
          <input class="form-control" type="text" name="description" v-model="structure.description">
          <span class="input-group-text">Description</span>
        </div>
        <div class="input-group mb-3">
          <input disabled class="form-control" type="text" name="link" v-model="structure.link">
          <span class="input-group-text">Link to original structure</span>
        </div>
        <div class="input-group mb-3">
          <input disabled class="form-control" type="text" name="plicLink" v-model="structure.plicLink">
          <span class="input-group-text">Link to plic structure</span>
        </div>
        <div class="input-group mb-3">
          <input class="form-control" type="text" name="pubmedId" v-model="structure.pubmedId">
          <span class="input-group-text">Pubmed Id</span>
          <a :href="'https://pubmed.ncbi.nlm.nih.gov/' + structure.pubmedId" target="_blank" v-if="structure.pubmedId"
             title="Open in pubmed"
             class="btn btn-outline-secondary" type="button"><span class="bi bi-arrow-up-right-square"></span></a>
        </div>
        <div class="input-group mb-3">
          <textarea disabled class="form-control" type="text" name="sequence" v-model="structure.sequence"></textarea>
          <span class="input-group-text">Sequence</span>
        </div>
        <div class="input-group mb-3">
          <TagsInput @update-tags="updateTags" :initial-tags="structure.tags ?? []"></TagsInput>
        </div>
        <button class="btn btn-success" style="margin-right: 5px" @click="updateStructure">Save</button>
        <button class="btn btn-info" style="margin-right: 5px" @click="loadRcsbData">Get RCSB Info</button>
        <button class="btn btn-info" style="margin-right: 5px" @click="parseSequence" :disabled="!this.structure.id">
          Parse sequence
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TagsInput from "./TagsInput.vue";
import LoadingOverlay from "../shared/LoadingOverlay.vue";

export default {
  props: {
    structure: {
      type: Object,
      required: true,
    },
  },
  components: {
    LoadingOverlay,
    TagsInput
  },
  data() {
    return {
      detailsShown: false,
      loading: false
    };
  },
  methods: {
    loadRcsbData() {
      this.loading = true;
      axios.get('/api/rcsb/info/' + this.structure.pdb).then((response) => {
        this.$emit("update-pubmed-id", response.data.pubmedId);
        this.$emit("update-description", response.data.description);
        this.loading = false;
      }, (error) => {
        console.log(error);
        this.loading = false;
      });
    },
    showDetails() {
      this.detailsShown = !this.detailsShown;
    },
    updateStructure() {
      this.loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append('pdb', this.structure.pdb);
      bodyFormData.append('link', this.structure.link);
      bodyFormData.append('plicLink', this.structure.plicLink);
      bodyFormData.append('description', this.structure.description);
      bodyFormData.append('pubmedId', this.structure.pubmedId);
      bodyFormData.append('tags', this.structure.tags);
      axios.post('/api/admin/structures/save', bodyFormData)
          .then((response) => {
            this.$emit("update-id", response.data);
            this.$emit("set-loaded-status", true);
            this.loading = false;
          }, (error) => {
            console.log(error);
            this.loading = false;
          });
    },
    updateTags(tags) {
      this.$emit("update-tags", tags);
    },
    makeToast(message) {
      this.$emit("toast-success", message);
    },
    parseSequence() {
      if (!this.structure.id) {
        return;
      }

      this.loading = true;
      var bodyFormData = new FormData();
      bodyFormData.append('structureId', this.structure.id);
      axios.post('/api/admin/structures/parse', bodyFormData)
          .then((response) => {
            this.$emit("update-protein-id", response.data.proteinId);
            this.$emit("update-sequence", response.data.sequence);
            this.loading = false;
            this.makeToast('Sequence was successfully updated!');
          }, (error) => {
            console.log(error);
            this.loading = false;
          });
    }
  },
  emits: ['update-pubmed-id', 'update-description', 'update-id', 'set-loaded-status', 'update-tags', 'update-sequence', 'update-protein-id', 'toast-success']
};
</script>
